import moment from 'moment'
import { getCurrentLanguage } from 'utils'

export function urlencoded(body) {
  const result = []
  // eslint-disable-next-line no-unused-vars
  for (const item in body) {
    // 去除数据中的undefined 和 空格
    if (body[item] && body[item] !== 'undefined') {
      const value = body[item].toString().replace(/ /g, '')
      result.push(`${item}=${encodeURIComponent(value)}`)
    }
  }
  return result.join('&')
}

export default function header({ method, endpoint, header, body, type, forward }) {
  // if (process.env.NODE_ENV === 'development') {
  //   type = 'dev'
  //   method = 'GET'
  // }
  if (method === 'GET' && body) {
    endpoint += `?${urlencoded(body)}`
  }
  const reqHeaders = {
    JSON: {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Content-Language': getCurrentLanguage(),
        platform: 4,
        'Utc-Offset-Seconds': moment().utcOffset() * 60,
        'x-device-id': window['x-device-id'],
        ...header,
      },
      credentials: 'include',
      body: method === 'POST' ? JSON.stringify(body) : undefined,
    },
    'x-www-form-urlencoded': {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      credentials: 'include',
      body: method === 'POST' && urlencoded(body),
    },
    dev: {
      credentials: 'omit',
    },
  }
  let url = `/api/${endpoint}`
  if (forward === false) {
    url = endpoint
  }
  return Object.assign({}, reqHeaders[type], {
    method: method,
    endpoint: url,
  })
}
